
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6V6D9", function(module, exports) {

$parcel$export(module.exports, "MenuComponent", () => $08c54687ab3c5499$export$c0941f68287dbcd1);
/* eslint-disable react/prop-types */ 
var $gwFzn = parcelRequire("gwFzn");

var $6xdDU = parcelRequire("6xdDU");

var $luv00 = parcelRequire("luv00");
const $08c54687ab3c5499$export$c0941f68287dbcd1 = ({ menu: Menu })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [activeDialog, setActiveDialog] = (0, $gwFzn.useState)(null);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        setIsOpen,
        isOpen
    ]);
    const onClose = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setActiveDialog(null);
    }, [
        setActiveDialog
    ]);
    const openDialog = (0, $gwFzn.useCallback)((dialog)=>{
        setActiveDialog(dialog(closeDialog));
    }, [
        setActiveDialog,
        closeDialog
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Menu, {
        openDialog: openDialog,
        onClose: onClose,
        onClick: onClick,
        isOpen: isOpen,
        ...ssrPlaceholderIdProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, activeDialog));
};

});
parcelRegister("6xdDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ad3bd6adfcceac$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $g9Srd = parcelRequire("g9Srd");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $64ad3bd6adfcceac$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g9Srd.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $64ad3bd6adfcceac$export$2e2bcd8739ae039 = $64ad3bd6adfcceac$var$ModalTransition;

});



//# sourceMappingURL=MenuComponent.d5755476.js.map
